import "./FallbackErrorUI.css";

import { useTranslation } from "react-i18next";

import { ErrorScreen } from "../ErrorScreen";

export function FallbackErrorUI() {
  const { t } = useTranslation();

  const refetch = () => window.location.reload();
  return (
    <div className="error-screen-container">
      <ErrorScreen
        errorText={t("errorState.error.somethingWentWrong")}
        refetch={refetch}
      />
    </div>
  );
}
